import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYoutubeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_21718_3348)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M15.6656 4.15039C15.4812 3.46289 14.9406 2.91914 14.25 2.73477C13.0031 2.40039 8 2.40039 8 2.40039C8 2.40039 2.99688 2.40039 1.75 2.73477C1.0625 2.91914 0.51875 3.45977 0.334375 4.15039C0 5.39727 0 8.00039 0 8.00039C0 8.00039 0 10.6035 0.334375 11.8504C0.51875 12.5379 1.05938 13.0816 1.75 13.266C2.99688 13.6004 8 13.6004 8 13.6004C8 13.6004 13.0031 13.6004 14.25 13.266C14.9375 13.0816 15.4812 12.541 15.6656 11.8504C16 10.6035 16 8.00039 16 8.00039C16 8.00039 16 5.39727 15.6656 4.15039Z",
			fill: "#A3A3A3"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M6.3999 10.3996L10.5562 7.99961L6.3999 5.59961V10.3996Z",
			fill: "black"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_21718_3348",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgYoutubeIcon;
